import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { RouteConstant } from 'src/app/core/_constants/route.constant';
import { LocalStorageProvider } from 'src/app/core/_services/common/storage.service';
import { AuthService } from 'src/app/core/_services/pages/auth.service';
import { PagesService } from 'src/app/core/_services/pages/pages.service';

@Component({
  selector: 'app-aside',
  templateUrl: './aside.component.html',
  styleUrls: ['./aside.component.scss']
})
export class AsideComponent implements OnInit {
  selectedNav: any = '';
  profileDetails: any;
  navigationList: ({ type: number; heading: string; routerLink: string; svg: string; isOpened?: undefined; subheading?: undefined; startWith: string; } | { type: number; heading: string; svg: string; isOpened: boolean; startWith: string; subheading: { heading: string; routerLink: string; }[]; routerLink?: string; })[];
  @Input('isOpen') isOpen = true;
  constructor(private route: Router, private dialog: MatDialog, private service: PagesService, private storageService: LocalStorageProvider, authService: AuthService) {
    this.profileDetails = this.storageService.getItem('CurrentUser');
    this.navigationList = [
      {
        type: 1,
        heading: 'Dashboard',
        routerLink: '/dashboard',
        svg: '/assets/images/dashboard.svg',
        startWith: 'dashboard'
      },
      {
        type: 1,
        heading: 'Clients',
        routerLink: '/client',
        svg: '/assets/images/work.svg',
        startWith: 'client'
      },
      {
        type: 2,
        heading: 'Coaching',
        svg: '/assets/images/coaching-fill.svg',
        isOpened: false,
        routerLink: `${RouteConstant.coaching}`,
        startWith: 'coaching',
        subheading: [
          {
            heading: 'Live Stream',
            routerLink: `${'/' + RouteConstant.coaching + '/' + RouteConstant.meetingList}`,
          },
          {
            heading: 'SG Feed',
            routerLink: `${'/' + RouteConstant.coaching + '/' + RouteConstant.feed}`,
          },
          {
            heading: 'Library',
            routerLink: `${'/' + RouteConstant.coaching + '/' + RouteConstant.library}`,
          },
        ]
      },
      {
        type: 1,
        heading: 'Payment History',
        routerLink: '/payment-history',
        svg: '/assets/images/payment-icon.svg',
        startWith: 'paymentHistory'
      },
      {
        type: 2,
        heading: 'Reporting',
        svg: '/assets/images/report-svgrepo-com.svg',
        isOpened: false,
        routerLink: `${RouteConstant.reporting}`,
        startWith: 'reporting',
        subheading: [
          {
            heading: 'Marketing Emails',
            routerLink: `${'/' + RouteConstant.reporting + '/' + RouteConstant.reportsEmail}`,
          },
          {
            heading: 'Distance API',
            routerLink: `${'/' + RouteConstant.reporting + '/' + RouteConstant.distanceReports}`,
          },
          {
            heading: 'SMS Messaging',
            routerLink: `${'/' + RouteConstant.reporting + '/' + RouteConstant.smsReports}`,
          },
          {
            heading: 'AI Phone Agent',
            routerLink: `${'/' + RouteConstant.reporting + '/' + RouteConstant.aiPhoneReports}`,
          },
        ]
      },
      {
        type: 1,
        heading: 'Support',
        routerLink: '/support',
        svg: '/assets/images/support-svgrepo-com.svg',
        startWith: 'support'
      },
      {
        type: 2,
        heading: 'Settings',
        svg: '/assets/images/settings-menu.svg',
        isOpened: false,
        routerLink: `${RouteConstant.settings}`,
        startWith: 'settings',
        subheading: [
          {
            heading: 'Notification Email',
            routerLink: `${'/' + RouteConstant.settings + '/' + RouteConstant.emailNotification}`,
          },
          {
            heading: 'Manage Distance API',
            routerLink: `${'/' + RouteConstant.settings + '/' + RouteConstant.distanceAPI}`,
          },
          {
            heading: 'Manage Industries',
            routerLink: `${'/' + RouteConstant.settings + '/' + RouteConstant.service}`,
          },
          {
            heading: 'Manage SMS',
            routerLink: `${'/' + RouteConstant.settings + '/' + RouteConstant.sms}`,
          },
          {
            heading: 'Email Verifications',
            routerLink: `${'/' + RouteConstant.settings + '/' + RouteConstant.marketingEmails}`,
          },
          {
            heading: 'Packages',
            routerLink: `${'/' + RouteConstant.settings + '/' + RouteConstant.packageList}`,
          },
          {
            heading: 'Payment Processing',
            routerLink: `${'/' + RouteConstant.settings + '/' + RouteConstant.paymentProcessing}`,
          },
          {
            heading: 'SuperAdmin Users',
            routerLink: `${'/' + RouteConstant.settings + '/' + RouteConstant.superAdmin}`,
          },
        ]
      },
      {
        type: 2,
        heading: 'Archived',
        svg: '/assets/images/Archive.svg',
        isOpened: false,
        routerLink: `${RouteConstant.archive}`,
        startWith: 'archive',
        subheading: [
          {
            heading: 'Customers',
            routerLink: `${'/' + RouteConstant.archive + '/' + RouteConstant.Customer}`,
          },
          {
            heading: 'Failed Login Attempts',
            routerLink: `${'/' + RouteConstant.archive + '/' + RouteConstant.invalidAttempts}`,
          },
        ]
      },
      // {
      //   type: 1,
      //   heading: 'Client Payments',
      //   routerLink: '/client-payment',
      //   svg: '/assets/images/payment-icon.svg',
      //   startWith: 'clientPayment'
      // },
    ];
  }

  isShow = false
  private intervalId: any;
  ngOnInit(): void {
    if (window.innerWidth > 1024) {
      this.isShow = true;
    }
    else {
      this.isShow = false
    }
    this.navigationList.forEach(element => {
      if (element.type == 2) {
        this.checkURLpresent(element)
      }
    });
    this.route.events.subscribe((value) => {
      if (value instanceof NavigationEnd) {
        if (value.url.split('/')[1] == 'my-profile') {
          this.singleLinkClicked()
        } else {
          this.navigationList.forEach(element => {
            if (element.startWith == value.url.split('/')[1]) {
              if (element.type == 2) {
                this.singleLinkClicked()
                this.closePanel(element)
              }
              else {
                this.singleLinkClicked();
              }
            }
          });
        }
      }
    });
    this.getCoachingNotifications();

    this.intervalId = setInterval(() => {
      this.getCoachingNotifications();
    }, 30000);
  }
  count: any;
  getCoachingNotifications() {
    this.service.get('', `${API_ROUTES.COACHING.getCount}`).subscribe({
      next: (response) => {
        if (response.status) {
          this.count = response?.data?.commnetCount + response?.data?.likecount;

        } else {
        }
      },
      error: (err) => {

      },
      // complete: () => this.loader.stop()
    })
  }
  closePanel(item) {
    if (item.isOpened) {
      if (!this.checkURLpresent(item)) {
        this.route.navigate([item.subheading[0].routerLink])
        this.navigationList.forEach(element => {
          if (element.type == 2 && element.heading !== item.heading) {
            element.isOpened = false;
          }
        });
      }
    }
    if (this.checkURLpresent(item)) {
      item.isOpened = true;
    }
  }

  singleLinkClicked(item?: any) {
    if (item && item.type == 2) {
      this.closePanel(item);
      // this.onClickNav.emit();
    }
    else {
      this.navigationList.forEach(element => {
        if (element.type == 2) {
          element.isOpened = false;
        }
      });
    }
    // if(item && item.type == 1){
    //   this.onClickNav.emit();
    // } 
  }

  showdropdown() {
    this.isShow = !this.isShow
  }

  checkURLpresent(item) {
    let url = this.route.url.split('?')[0];
    let links = item.subheading.map((item) => item.routerLink);
    if (links.includes('/coaching/feed') || links.includes('/coaching/library')) {
      links.push(`${'/' + RouteConstant.coaching + '/' + RouteConstant.library + '/' + RouteConstant.uploadVideo}`);
      links.push(`${'/' + RouteConstant.coaching + '/' + RouteConstant.library + '/' + RouteConstant.videoList}`);
      links.push(`${'/' + RouteConstant.coaching + '/' + RouteConstant.library + '/' + RouteConstant.videoDetail}`);
      links.push(`${'/' + RouteConstant.coaching + '/' + RouteConstant.feed + '/' + RouteConstant.uploadVideo}`);
      links.push(`${'/' + RouteConstant.coaching + '/' + RouteConstant.feed + '/' + RouteConstant.uploadText}`);
      links.push(`${'/' + RouteConstant.coaching + '/' + RouteConstant.feed + '/' + RouteConstant.uploadImage}`);
    }
    if (links.includes('/settings/package-list')) {
      links.push(`${'/' + RouteConstant.settings + '/' + RouteConstant.packageList + '/' + RouteConstant.editPackage}`);
    }
    if (links.includes(url)) {
      item.isOpened = true;
      return true;
    }
    return false;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (window.innerWidth > 1024) {
      this.isShow = true;
    }
  }
  ngOnDestroy() {
    // Clear the interval when the component is destroyed
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}